import React from 'react';
import { Plus, Minus } from 'lucide-react';

export const TimeStandardControl = ({ label, value, onChange, min = 1, max = 999 }) => {
  const numValue = parseInt(value, 10) || 0;

  const handleIncrement = () => {
    const newValue = Math.min(numValue + 1, max);
    onChange(newValue.toString());
  };

  const handleDecrement = () => {
    const newValue = Math.max(numValue - 1, min);
    onChange(newValue.toString());
  };

  const handleInputChange = (e) => {
    const val = e.target.value;

    // Allow empty string for editing
    if (val === '') {
      onChange('');
      return;
    }

    const num = parseInt(val, 10);
    if (!Number.isNaN(num) && num >= min && num <= max) {
      onChange(val);
    }
  };

  return (
    <div>
      <label className="block font-['Roboto:Medium',sans-serif] text-[13px] text-gray-700 mb-2">
        {label}
      </label>

      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={handleDecrement}
          disabled={numValue <= min}
          className="w-9 h-9 rounded-lg flex items-center justify-center bg-white text-gray-600 border border-[#D3D3D3] hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          <Minus className="w-4 h-4" />
        </button>

        <input
          type="number"
          value={value}
          onChange={handleInputChange}
          min={min}
          max={max}
          className="flex-1 w-full min-w-0 max-w-[100px] px-3 py-2 text-center border border-[#D3D3D3] rounded-lg font-['Roboto:Regular',sans-serif] text-[14px] text-gray-900 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-[#61b8e7] focus:border-[#61b8e7] bg-white"
        />

        <button
          type="button"
          onClick={handleIncrement}
          disabled={numValue >= max}
          className="w-9 h-9 rounded-lg flex items-center justify-center bg-white text-gray-600 border border-[#D3D3D3] hover:bg-gray-50 disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
        >
          <Plus className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
